// Every page is its own chunk, named after a hash of its content and fetched the first time the page
// is opened. A deploy replaces the whole build, so an app loaded before the deploy asks for file names
// that no longer exist: the import fails and the page shows its error screen until a manual refresh.
// Vite reports every failed dynamic import as `vite:preloadError`. Reloading fetches the new
// index.html with the new names, and the page being opened loads.
//
// A reload cannot help when a file is really missing, and would then repeat forever. So it happens
// at most once a minute: a second failure within that time shows the error screen instead.
const LAST_RELOAD_KEY = 'stale-chunk-reload-at';
const MIN_RELOAD_INTERVAL_MS = 60_000;

function reloadOnce() {
    try {
        const lastReloadAt = Number(sessionStorage.getItem(LAST_RELOAD_KEY));
        if (Date.now() - lastReloadAt < MIN_RELOAD_INTERVAL_MS) {
            return;
        }
        sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
    }
    catch {
        // Without storage nothing guards against a reload loop, so leave the error screen to the user.
        return;
    }
    window.location.reload();
}

export function reloadOnStaleChunk() {
    window.addEventListener('vite:preloadError', reloadOnce);
    return () => window.removeEventListener('vite:preloadError', reloadOnce);
}
